import { FilterDefinition, FilterValue } from "../types";
import SearchFilterTags from "./SearchFilterTags";

type AppliedFilterTagsProps<TSearch, TFilterOptions> = {
  /** The surface's registry, so one component serves products and product lines alike. */
  definitions: FilterDefinition<TSearch, FilterValue, TFilterOptions>[];
  options: TFilterOptions;
  value: TSearch;
  onChange: (next: Partial<TSearch>) => void;
};

/** A removable chip per selected value, across every filter the surface offers. */
const AppliedFilterTags = <TSearch, TFilterOptions>({
  definitions,
  options,
  value,
  onChange,
}: AppliedFilterTagsProps<TSearch, TFilterOptions>) => (
  <>
    {definitions.map((definition) => (
      <SearchFilterTags<FilterValue>
        key={definition.key}
        options={definition.optionsFrom(options) ?? []}
        value={definition.selectedFrom(value)}
        onChange={(next) => onChange(definition.toUpdate(next, value))}
      />
    ))}
  </>
);

export default AppliedFilterTags;
